export default __webpack_public_path__ + "static/media/liveFeedCostCode.97a1afc7.png";